import React from 'react'
import './services.css'
import {MdPlaylistAddCheckCircle} from 'react-icons/md'
export const Services = () => {
  return (
    <section id = "services">
       <h5>
        what I offer
       </h5>
       <h2>
        services
       </h2>

       <article className="spcialized  container service">

          <div className="service_head">
            <h2 className="Spe">  Web Application Development</h2>
          </div>
          <ul className="service_list">
            <li>
                <div className="service_head">
                    <MdPlaylistAddCheckCircle className="list_icon" />
                    <h4 className="_center">Website design and development</h4>
                </div>
                <p>visually appealing and functional website that meets the needs of the client and their target audience</p>
            </li>
            <li>
              <div className="service_head">
                <MdPlaylistAddCheckCircle className="list_icon" />
                <h4 className="_center">User experience (UX) design </h4>
                </div>
                <p>easy to use and meets the needs of the user</p>
                
            </li>
            <li>
              <div className="service_head">
                <MdPlaylistAddCheckCircle className="list_icon" />
                <h4 className="_center">Responsive design </h4>
                </div>
                <p>optimized for different screen sizes and devices</p>
                
            </li>
            <li>
              <div className="service_head">
                <MdPlaylistAddCheckCircle className="list_icon" />
                <h4 className="_center">Content creation </h4>
                </div>
                <p>high-quality content for the website, including text, images, and videos</p>
            </li>
            <li>
                <div className="service_head ">
                <MdPlaylistAddCheckCircle className="list_icon" />
                <h4 className="_center">Website maintenance </h4>
                </div>
                <p>ongoing maintenance and support for the website</p>
            </li>
          </ul>
      </article>
      <div className="service_container container">
        <article className="service">

          <div className="service_head">
            <h2> Custom Software Development</h2>
          </div>
          <ul className="service_list">
              {/* <li>
                  <MdPlaylistAddCheckCircle className="list_icon" />
                  <p>Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum </p>
              </li> */}
          </ul>
        </article>
        <article className="service">

            <div className="service_head">
              <h2> Mobile Application Development</h2>
            </div>
            <ul className="service_list">
              {/* <li>
                  <MdPlaylistAddCheckCircle className="list_icon" />
                  <p>Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum </p>
              </li> */}
            </ul>
        </article>
        <article className="service">

            <div className="service_head">
              <h2> Systems Integration</h2>
            </div>
            <ul className="service_list">
              {/* <li>
                  <MdPlaylistAddCheckCircle className="list_icon" />
                  <p>Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum </p>
              </li> */}
            </ul>
        </article>
    </div>
    </section >
  )
}
